module.exports = __webpack_public_path__ + "img/success.19ad2265.png";